import styled from "styled-components";

export const AutomationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: calc(100vh - 48px);
  overflow: hidden;
  padding-block-start: 24px;
`;

export const AutomationContent = styled.div`
  display: flex;
  gap: 24px;
  flex-direction: column;
  width: 100%;
  height: 100%;

  h1 {
    font-size: 24px;
    font-weight: 600;
    margin: 0 0 16px 0;
  }

  p {
    font-size: 16px;
    color: ${(props) => props.theme.colors.davysGrey};
    margin: 0;
  }
`; 